function setMeta(name, content) {
  if (!content) return;
  let element = document.head.querySelector(`meta[name="${name}"]`);
  if (!element) {
    element = document.createElement('meta');
    element.setAttribute('name', name);
    document.head.appendChild(element);
  }
  element.setAttribute('content', content);
}

export default function applyBranding(settings) {
  if (!settings || typeof document === 'undefined') return;
  const values = settings.settings || settings;
  const title = values.app_titel;
  const themeColor = values.app_theme_color_primary;

  if (title) {
    document.title = title;
    setMeta('apple-mobile-web-app-title', title);
    setMeta('application-name', title);
  }
  setMeta('theme-color', themeColor);
  setMeta('msapplication-TileColor', themeColor);

  // Alle vom PWA-Plugin oder älteren Builds eingefügten Vue-Favicons entfernen.
  document.head.querySelectorAll('link[rel="icon"], link[rel="shortcut icon"]')
    .forEach((element) => element.remove());

  const icon = document.createElement('link');
  icon.setAttribute('rel', 'icon');
  icon.setAttribute('type', 'image/x-icon');
  const version = process.env.VUE_APP_VERSION || 'current';
  const base = process.env.BASE_URL || '/';
  icon.setAttribute('href', `${base}favicon.ico?v=${encodeURIComponent(version)}&host=${encodeURIComponent(window.location.hostname)}`);
  document.head.appendChild(icon);
}
